import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AppImportStepperComponent} from './components/import-stepper/app-import-stepper.component';
import {ImportComponent} from './components/import/import.component';
import {ExportComponent} from './components/export/export.component';
import {AppExportStepperComponent} from './components/export-stepper/app-export-stepper.component';
import { StepperNavigationComponent } from './components/stepper-navigation/stepper-navigation.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'import-stepper',
        pathMatch: 'full'
    },
    {
        path: 'import-stepper',
        component: AppImportStepperComponent
    },
    {
        path: 'import',
        component: ImportComponent
    },
    {
        path: 'export-stepper',
        component: AppExportStepperComponent
    },
    {
        path: 'export',
        component: ExportComponent
    },
    {
        path: 'navigation',
        component: StepperNavigationComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
